import React, { Component } from 'react';
import { withLanguageContext } from '../../../utils/LanguageContext';
import LearnMore from '../../templates/LearnMore';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Object} content
 *
 * @augments {Component<Props>}
 */
export class LearnMoreView extends Component {

	render () {
		const {
			buttonLabel,
			fileName,
			heading,
		} = this.props.content.landingPage.downloadBrochure;
		return (
			<div className='LearnMoreView'>
				<LearnMore 	{...{
					buttonLabel,
					fileName,
					heading,
				}} />
			</div>
		);
	}

}

export default withLanguageContext(LearnMoreView);



// WEBPACK FOOTER //
// ./src/components/views/LearnMoreView/LearnMoreView.js